import { apiClient } from "../apiClient";

export const DIEM_QUY_DOI_ENDPOINT = "diem-quy-doi";
export const diemQuyDoiApi = {
    SelectAll: () => apiClient.get(`${DIEM_QUY_DOI_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(DIEM_QUY_DOI_ENDPOINT, payload),
    Update: (id: number, payload: any) => apiClient.put(`${DIEM_QUY_DOI_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${DIEM_QUY_DOI_ENDPOINT}/${id}`),
}